import { render, staticRenderFns } from "./RestrictedReopenModal.vue?vue&type=template&id=6b499826&scoped=true&"
import script from "./RestrictedReopenModal.vue?vue&type=script&lang=js&"
export * from "./RestrictedReopenModal.vue?vue&type=script&lang=js&"
import style0 from "./RestrictedReopenModal.vue?vue&type=style&index=0&id=6b499826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b499826",
  null
  
)

export default component.exports